var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocketlaneIconStandard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 360,
  height: 360,
  viewBox: "0 0 360 360",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.486 66.6374L318.193 180.568L266.486 294.499C254.936 298.211 242.621 300.216 229.838 300.216C212.2 300.216 195.453 296.399 180.378 289.547L229.838 180.568L180.378 71.5894C195.453 64.7369 212.2 60.9203 229.838 60.9203C242.621 60.9203 254.936 62.9251 266.486 66.6374Z",
  fill: "#0F62FE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.536 67.6224L180.378 179.648L129.536 291.673C116.436 296.6 102.243 299.296 87.4211 299.296C71.269 299.296 55.8643 296.095 41.8069 290.293L92.023 179.648L41.8069 69.0022C55.8643 63.2006 71.269 60 87.4211 60C102.243 60 116.436 62.6952 129.536 67.6224Z",
  fill: "black"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocketlaneIconStandard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocketlane_icon_standard.451c08ac29bf775446104bf586a94132.svg";